import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import { fg } from '@atlaskit/platform-feature-flags';

import { IssueReformatterIcon } from '../../../../icons/prompt/issueReformatter';
import { createInsertBelow, createReplace } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptions,
	EditorPluginAIConfigItem,
} from '../../config-items';

export type GetAdditionalProps = () => Partial<{
	issue_summary?: string;
	issue_type_label?: string;
}>;

type Options = {
	getAdditionalProps: GetAdditionalProps;
};

export const createImproveDescription = (options: Options): EditorPluginAIConfigItem => ({
	key: CONFIG_ITEM_KEYS.ADD_STRUCTURE,
	title: aiConfigItemMessages.improveDescription,
	description: aiConfigItemMessages.reformatWithTemplateDescription,
	icon: () => <IssueReformatterIcon />,
	experienceId: 'issue-reformatter',
	intentSchemaId: 'issue_reformatter_intent_schema.json',
	alwaysNeedDoc: true,
	getRequestPayload: ({ locale, doc }) => {
		return {
			recipient_agent_named_id: 'jira_issue_reformatter_agent',
			agent_input_context: {
				locale,
				issue_description: doc,
				...options.getAdditionalProps?.(),
			},
		};
	},
	...(fg('migrate_editor_issue_reformatter_to_convo-ai')
		? {
				endpoint: '/gateway/api/assist/api/ai/v2/ai-feature/jira/issue/reformatter',
				getRequestPayload: ({ locale, doc }) => ({
					ai_feature_input: {
						locale,
						issue_description: doc,
						...options.getAdditionalProps?.(),
					},
				}),
			}
		: {}),
	actions: {
		empty: [
			createInsertBelow({ appearance: 'secondary' }),
			createReplace({ appearance: 'primary' }),
		],
		selection: [
			createInsertBelow({ appearance: 'secondary' }),
			createReplace({ appearance: 'primary' }),
		],
	},
	getBackendModel: () => 'assistance-service',
});

export const createImproveDescriptionWithOptions = (
	options: Options,
): EditorPluginAIConfigItemWithOptions => ({
	config: createImproveDescription(options),
	triggers: { empty: { enabled: true, docMinSize: 1 }, selection: { enabled: true } },
});
